import { render, staticRenderFns } from "./NotesModal.vue?vue&type=template&id=a5b007e0&scoped=true&"
import script from "./NotesModal.vue?vue&type=script&lang=js&"
export * from "./NotesModal.vue?vue&type=script&lang=js&"
import style0 from "./NotesModal.vue?vue&type=style&index=0&id=a5b007e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b007e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5b007e0')) {
      api.createRecord('a5b007e0', component.options)
    } else {
      api.reload('a5b007e0', component.options)
    }
    module.hot.accept("./NotesModal.vue?vue&type=template&id=a5b007e0&scoped=true&", function () {
      api.rerender('a5b007e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NotesModal.vue"
export default component.exports